import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import entrepriseGuideSteps from '../../guides/entrepriseGuideSteps';
import UserGuide from '../../commun/UserGuide';
import StarIcon from '@mui/icons-material/Star';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SavingsIcon from '@mui/icons-material/Savings';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import { Avatar, Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Typography } from '@mui/material';
import './Dashboard.css';
import Footer from '../../commun/Footer';
import Chatbox from '../../commun/ChatBox';
import HeaderEntreprise from '../../header/headerEntreprise';
import MissionsList from '../../Recruteur/Dashboard/MissionsList';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Assignment';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CandidaturesList from './CandidaturesList';
import LoadingPopup from "../../commun/LoadingPopup";


const MultiDeviseAmount = ({ montantObj }) => (
  <>
    {montantObj && Object.entries(montantObj).map(([devise, montant]) =>
      montant > 0 && (
        <Typography variant="h5" key={devise}>
          {montant.toLocaleString()} {devise}
        </Typography>
      )
    )}
  </>
);

const DashboardEntreprise = () => {
  const entrepriseName = localStorage.getItem("entrepriseName");
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem('authToken');
  const entrepriseId = localStorage.getItem('entrepriseId');
  const userId = localStorage.getItem('userId');

  const [entrepriseStats, setEntrepriseStats] = useState(null);
  const [missions, setMissions] = useState([]);
  const [openPrime, setOpenFactureEstimée] = useState(false);
  const [openCagnotte, setOpenCagnotte] = useState(false);
  const [openNiveau, setOpenNiveau] = useState(false);
  const [openTopRecruteur, setOpenTopRecruteur] = useState(false);
  const [factures, setFactures] = useState([]);
  const [loadingFactures, setLoadingFactures] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  
useEffect(() => {
  if (!entrepriseId) return;

  const fetchFactures = async () => {
    setLoadingFactures(true);
    try {
      const res = await fetch(`${API_BASE}/api/entreprise/facture/${entrepriseId}`);
      const data = await res.json();
      const unpaidFactures = data.filter(f => f.statutPaiement !== 'Payée');
      setFactures(unpaidFactures);
    } catch (err) {
      console.error("Erreur lors du chargement des factures :", err);
    } finally {
      setLoadingFactures(false);
    }
  };

  fetchFactures();
}, [API_BASE, entrepriseId]);

useEffect(() => {
  const checkTourGuide = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/user/tour-guide`, {
        params: {userId}
      });
      if (!res.data.tourGuideSeen) {
        setShowGuide(true);
      }
    } catch (err) {
      console.error('Erreur en récupérant le tour guide status:', err);
    }
  };

  checkTourGuide();
}, [entrepriseId]);

useEffect(() => {
  fetch(`${API_BASE}/api/entreprise-stats`, {
    headers: { Authorization: `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => setEntrepriseStats(data));

  fetch(`${API_BASE}/api/missions/all`)
    .then(res => res.json())
    .then(data => setMissions(Array.isArray(data) ? data.slice(0, 4) : []));

}, [API_BASE, token]);

  if (!entrepriseStats) return 
      <LoadingPopup
      open={!entrepriseStats}
      message="Chargement..."
    />;

  const statsData = [
    {
      label: 'Missions totales',
      value: entrepriseStats.stats.totalMissions || 0,
      className: 'stat-missions',
      icon: <BusinessIcon className="stat-badge-icon" />,
      detailsKey: 'missions'
    },
    {
      label: 'Candidatures reçues',
      value: entrepriseStats.stats.candidaturesPresentees,
      className: 'stat-candidats',
      icon: <PeopleIcon className="stat-badge-icon" />,
      detailsKey: 'candidatures'
    },
    {
      label: 'En entretien',
      value: entrepriseStats.stats.enEntretien,
      className: 'stat-entretiens',
      icon: <ThumbUpIcon className="stat-badge-icon" />,
      detailsKey: 'entretiens'
    },
    {
      label: 'Missions terminées',
      value: entrepriseStats.stats.missionsTerminees,
      className: 'stat-recrutes',
      icon: <CheckCircleIcon className="stat-badge-icon" />,
      detailsKey: 'terminees'
    },
  ];

  return (
    <Box>
      {showGuide && (
        <UserGuide
          stepsKey="entrepriseDashboardGuide"
          steps={entrepriseGuideSteps}
          onFinish={async () => {
           setShowGuide(false);
            try {
              await axios.patch(`${API_BASE}/api/user/tour-guide`, { userId });
            } catch (err) {
              console.error(err);
            }
          }}
          autoStart={true}
        />
      )}

      <HeaderEntreprise entrepriseName={entrepriseName} />
      <Box className="dashboard-container">
      <div className="dashboard-flex">

        {/* Bloc gauche : Stats + Missions */}
        <div className="dashboard-rec ">
          <Typography variant="h5" mb={2}>Statistiques</Typography>
          <div className="stats-badge-flex guide-statistiques">
            {statsData.map((stat, i) => (
              <div className={`stat-badge-flat ${stat.className}`} key={i}>
                <span className="stat-badge-icon">{stat.icon}</span>
                <span className="stat-badge-content">
                  <span className="stat-badge-label">{stat.label}</span>
                  <span className="stat-badge-value">{stat.value || 0}</span>
                </span>
              </div>
            ))}
          </div>
          <Typography variant="h6" gutterBottom>Dernières candidatures</Typography>
         <CandidaturesList
          candidatures={
          entrepriseStats.details.candidaturesPresentees
          .filter(c => c.statut && 
          c.statut
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .trim().toLowerCase() === 'a traiter'
          )
          .sort((a, b) => new Date(b.dateCandidature) - new Date(a.dateCandidature))
          .slice(0, 4)
          }
          onView={id => navigate(`/Entreprise/DetailsCandidature/${id}`)}
          />
        </div>

        {/* Bloc droit vertical */}
        <div className="dashboard-side-vertical">
          {/* Cagnotte */}
          <Card className="dashboard-side-card cagnotte-card-modern guide-mes-factures">
            <div className="side-icon-wrap" style={{ background: "#d1f6ec" }}>
              <SavingsIcon className="side-card-icon" style={{ color: "#16a085" }} />
            </div>
            <CardContent>
              <div className="side-card-label">Mes factures</div>
              <div className="side-card-value">
              <MultiDeviseAmount montantObj={entrepriseStats.details.sommeFacturesParDevise} />
              </div>
              <div className="side-card-desc">Montant total des recrutements validés</div>
              <Button
                onClick={() => setOpenCagnotte(true)}
                size="small"
                variant="outlined"
                className="side-card-btn"
              >En savoir plus</Button>
            </CardContent>
          </Card>
          {/* Prime estimée */}
          <Card className="dashboard-side-card prime-card-modern guide-factures-estimees">
            <div className="side-icon-wrap" style={{ background: "#ede7f6" }}>
              <MonetizationOnIcon className="side-card-icon" style={{ color: "#7c4dff" }} />
            </div>
            <CardContent>
              <div className="side-card-label">Dépenses prévisionnelles</div>
              <div className="side-card-value">
              <MultiDeviseAmount montantObj={entrepriseStats.details.sommeFacturesEstimeesParDevise} />
              </div>
              <div className="side-card-desc">Potentiel basé sur la base de vos missions actives.</div>
              <Button
                onClick={() => setOpenFactureEstimée(true)}
                size="small"
                variant="outlined"
                className="side-card-btn"
              >En savoir plus</Button>
            </CardContent>
          </Card>

          {/* Top recruteurs */}
          <Card className="dashboard-side-card recruteur-card-modern niveau-card-modern guide-top-recruteurs">
            <div className="side-icon-wrap" style={{ background: "#e3f2fd" }}>
              <PeopleIcon className="side-card-icon" style={{ color: "#1976d2" }} />
            </div>

            <CardContent>
              <div className="side-card-label">Top Recruteurs</div>

              {(() => {
                const topRecruteurs = entrepriseStats.details.topRecruteurs
                  .filter((recruteur) => recruteur.totalTalentsRecruited > 0)
                  .slice(0, 3);

                if (topRecruteurs.length === 0) {
                  return <div style={{ textAlign: "center", color: "#888", marginTop: "12px" }}>No top match</div>;
                }

                return topRecruteurs.map((recruteur) => {
                  const photoUrl = recruteur.photo 
                    ? `${API_BASE}${recruteur.photo}?${Date.now()}`
                    : null;

                  return (
                    <div key={recruteur.id} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      marginTop: '14px'
                    }}>
                      <Avatar
                        src={photoUrl}
                        alt={`${recruteur.firstName} ${recruteur.lastName}`}
                        style={{
                          width: '40px',
                          height: '40px',
                          fontSize: '0.9rem',
                          color: '#fff'
                        }}
                      >
                        {!photoUrl && `${recruteur.firstName.charAt(0)}${recruteur.lastName.charAt(0)}`}
                      </Avatar>

                      <div>
                        <div className="side-card-value" style={{ fontSize: "0.95rem" }}>
                          <Link to={`/profil/${recruteur.id}`} className="recruteur-link">
                            {recruteur.firstName} {recruteur.lastName}
                          </Link>
                        </div>
                        <div className="side-card-desc" style={{ fontSize: "0.82rem" }}>
                          {recruteur.email}
                        </div>
                        <div className="side-card-desc" style={{ color: "#4caf50", fontSize: "0.82rem" }}>
                          {recruteur.totalTalentsRecruited} talents recrutés
                        </div>
                      </div>
                    </div>
                  );
                });
              })()}

              <Button
                onClick={() => setOpenTopRecruteur(true)}
                size="small"
                variant="outlined"
                className="side-card-btn"
                style={{ marginTop: '16px' }}
              >
                En savoir plus
              </Button>
            </CardContent>
          </Card>


        </div>
      </div>

      {/* Modales */}
      <Dialog open={openPrime} onClose={() => setOpenFactureEstimée(false)} maxWidth="sm" fullWidth>
        <DialogTitle>💰 Dépenses prévisionnelles</DialogTitle>
        <DialogContent dividers>
          {entrepriseStats.details.facturesEstimees.length > 0 ? (
            entrepriseStats.details.facturesEstimees.map((facture, index) => (
              <div key={index} className="recruteur-item recruteur-card">
                <Avatar className="facture-avatar">
                  #{facture.numeroFacture}
                </Avatar>

                <div style={{ flex: 1, marginLeft: '12px' }}>
                  <div className="side-card-value" style={{ fontSize: "1rem" }}>
                    {facture.mission}
                  </div>
                  <div className="side-card-desc">
                    Recruteur : 
                    <Link to={`/profil/${facture.RecruteurId}`} className="recruteur-link">
                      {facture.Recruteur}
                    </Link>
                  </div>
                  <div className="side-card-desc">
                    Statut : <strong>{facture.statut}</strong>
                  </div>
                  <div className="side-card-desc" style={{ color: "#7c4dff", fontWeight: "bold" }}>
                    Montant estimé : {facture.montant}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <Typography>Aucune facture estimée disponible.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFactureEstimée(false)}>Fermer</Button>
        </DialogActions>
      </Dialog>


      <Dialog open={openCagnotte} onClose={() => setOpenCagnotte(false)} maxWidth="sm" fullWidth>
  <DialogTitle>✅ Factures Confirmées</DialogTitle>
  <DialogContent dividers>
    {loadingFactures ? (
      <Typography>Chargement des factures...</Typography>
    ) : factures.length > 0 ? (
      factures.map((facture, index) => (
        <div key={index} className="recruteur-item recruteur-card">
          <Avatar className="facture-avatar">
            #{facture.numeroFacture}
          </Avatar>

          <div style={{ flex: 1, marginLeft: '12px' }}>
            <div className="side-card-value" style={{ fontSize: "1rem" }}>
              {facture.mission?.nomMission || 'Mission inconnue'}
            </div>

            <div className="side-card-desc">
              Recruteur :  
              <Link to={`/profil/${facture.recruteur?._id}`} className="recruteur-link">
                 {facture.recruteur?.firstName} {facture.recruteur?.lastName}
              </Link>
            </div>

            <div className="side-card-desc montant-estime" style={{ color: "#2e7d32", fontWeight: "bold" }}>
              Montant : {facture.montant} {facture?.devise ||'EUR'}
            </div>

            <div className="side-card-desc">
              Statut :{' '}
              {facture.statutPaiement === 'Payée' ? (
                <span style={{ fontWeight: 'bold', color: 'green' }}>
                  Payée
                </span>
              ) : (
                <span style={{ fontWeight: 'bold', color: 'red' }}>
                  Non payée
                </span>
              )}
            </div>

          </div>

          <div>
            <Button
              variant="outlined"
              size="small"
              onClick={() =>
                navigate(`/facture/${facture._id}`, {
                  state: { facture: facture },
                })
              }
            >

              Voir détails
            </Button>
          </div>
        </div>
      ))
    ) : (
      <Typography>Aucune facture confirmée pour le moment.</Typography>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenCagnotte(false)}>Fermer</Button>
  </DialogActions>
</Dialog>


      <Dialog open={openNiveau} onClose={() => setOpenNiveau(false)} maxWidth="sm" fullWidth>
        <DialogTitle>⭐ Niveaux & réputation</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Votre niveau indique votre engagement sur la plateforme :
          </Typography>
          <ul>
            <li><strong>Débutant</strong> : Aucun profil recruté. Merci de poursuivre vos efforts !</li>
            <li><strong>Intermédiaire</strong> : 2 profils recrutés.</li>
            <li><strong>Confirmé</strong> : 4 profils recrutés.</li>
            <li><strong>Expert</strong> : 6 profils recrutés.</li>
            <li><strong>Légende</strong> : 10 profils recrutés ou plus.</li>
          </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenNiveau(false)}>Fermer</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openTopRecruteur} onClose={() => setOpenTopRecruteur(false)} maxWidth="sm" fullWidth>
        <DialogTitle>💰 Top Recruteurs</DialogTitle>
        <DialogContent dividers>
          {(() => {
            const topRecruteurs = entrepriseStats.details.topRecruteurs.filter(
              (recruteur) => recruteur.totalTalentsRecruited > 0
            );

            if (topRecruteurs.length === 0) {
              return <div style={{ textAlign: "center", color: "#888" }}>No top match</div>;
            }

            return topRecruteurs.map((recruteur) => {
              const photoUrl = recruteur.photo 
                ? `${API_BASE}${recruteur.photo}?${Date.now()}`
                : null;

              return (
                <div key={recruteur.id} className="recruteur-item recruteur-card" >
                  {/* Recruiter Avatar */}
                  <Avatar
                    src={photoUrl}
                    alt={`${recruteur.firstName} ${recruteur.lastName}`}
                    style={{
                      width: '48px',
                      height: '48px',
                      border: '2px solid #e3f2fd',
                    }}
                  >
                    {!photoUrl && `${recruteur.firstName.charAt(0)}${recruteur.lastName.charAt(0)}`}
                  </Avatar>
                  
                  <div style={{ flex: 1 }}>
                    <div className="side-card-value" style={{ fontSize: "1rem" }}>
                    {recruteur.firstName} {recruteur.lastName}
                    </div>
                    <div className="side-card-desc">
                      {recruteur.email}
                    </div>
                    <div className="side-card-desc" style={{ color: "#4caf50" }}>
                      {recruteur.totalTalentsRecruited} talents recrutés
                    </div>
                  </div>
                </div>
              );
            });
          })()}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenTopRecruteur(false)}>Fermer</Button>
        </DialogActions>
      </Dialog>
    </Box>
    <Chatbox userRole="entreprise" />

     <Footer />
  </Box>
  );
};

export default DashboardEntreprise;
